import React from 'react';
import AnimateCC from 'react-adobe-animate';

export default () => (
  <AnimateCC
    animationName="dismoiwebsitecoveranimation"
    composition="5ED811F4CA4D4A1082E6963D6B77B249"
  />
);
